import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex items-center justify-center w-full h-full z-50 fixed left-0 top-0 bg-black bg-opacity-80"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center space-x-1 text-sm text-white" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    class: "w-12 h-12 animate-spin",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Pesquisando ...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "p-4" }

import { useSearchStore } from '@/stores/search'
import ListWordsVue from '@/components/Search/ListWords.vue'
import SearchResult from '@/components/Search/SearchResult.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const searchStore = useSearchStore()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(searchStore).loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ListWordsVue),
      _createVNode(SearchResult)
    ])
  ], 64))
}
}

})